import { ACCENT2, SIDEBAR_BG } from "../theme";

// Slim bar at the top of every phone and tablet screen: the Canopy name on the left, and the business
// initial on the right, which opens the More sheet (account actions). Desktop has the sidebar instead.
// Not sticky. Keeps clear of the iPhone notch.
function MobileLogoBar({ name, onOpenMore }) {
  const initial = ((name || "U").trim()[0] || "U").toUpperCase();
  return (
    <header className="mob-logobar" style={{ background: SIDEBAR_BG, paddingTop: "env(safe-area-inset-top, 0px)" }}>
      <div style={{ minHeight: 48, padding: "0 16px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
        <div style={{ fontFamily: "'Lora',serif", fontSize: 20, fontWeight: 500, color: "#F5EFE3", letterSpacing: "-0.01em" }}>Canopy</div>
        <button type="button" aria-label="Account and more" onClick={onOpenMore}
          style={{ width: 44, height: 44, margin: "0 -6px 0 0", background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span aria-hidden="true" style={{ width: 32, height: 32, borderRadius: "50%", background: `${ACCENT2}55`, color: "#F5EFE3", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, fontWeight: 600, fontFamily: "'DM Sans',sans-serif" }}>{initial}</span>
        </button>
      </div>
    </header>
  );
}

export { MobileLogoBar };
